import { useMutation } from '@tanstack/react-query';
import { ApiClient } from '../helpers';
import urls, { constructUrl } from 'src/shared/urls';
import { useEffect } from 'react';

type PurchaseGalleryData = {
  email?: string;
  galleryUUID: string;
  password?: string;
  quality: string;
};

const purchaseGalleryMutation = (data: PurchaseGalleryData) =>
  new ApiClient().post(constructUrl(urls.post.purchase.gallery), { data }).then((res) => res.body);

export const usePurchaseGallery = () => {
  const mutation = useMutation({
    mutationFn: (data: PurchaseGalleryData) => purchaseGalleryMutation(data),
  });

  useEffect(() => {
    if (mutation.data) {
      const { cbpSuccess, redirectURL } = mutation.data;

      if (cbpSuccess) {
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      } else if (redirectURL) {
        window.location.href = mutation.data.redirectURL;
      }
    }
  }, [mutation.data]);

  return mutation;
};
